import { daysAgo } from './dataset';

// Settings pages: Manage Teams, Navigation Control, Filter Composer, Saved Tags & Filters, Claim Location.
// Several endpoints are called again with an id to load one item (edit / expand rows).
// axios has already serialised the request body to a JSON string when it reaches the adapter.
const body = config => {
	const d = config && config.data;
	if (!d) return {};
	if (typeof d === 'object') return d;

	try {
		return JSON.parse(d);
	} catch (e) {
		return {};
	}
};

const TEAMS = [{
	teamId: 'team-northwest-ops',
	teamName: 'Northwest Ops',
	users: ['dana@brightsidecoffee.com', 'marc@brightsidecoffee.com', 'tom@brightsidecoffee.com'],
	activeUsers: ['Dana Whitfield', 'Marc Oyelaran'],
	pausedUsers: ['Tom Beckett'],
	createTime: daysAgo(130),
	updateTime: daysAgo(14)
}, {
	teamId: 'team-reviews-desk',
	teamName: 'Reviews Desk',
	users: ['priya@brightsidecoffee.com', 'alia@brightsidecoffee.com', 'dana@brightsidecoffee.com'],
	activeUsers: ['Priya Raman', 'Alia Nasser', 'Dana Whitfield'],
	pausedUsers: [],
	createTime: daysAgo(90),
	updateTime: daysAgo(6)
}];
const KEYWORD_GROUPS = [{
	keywordGroupId: 'kg-service',
	keywordGroupName: 'Service',
	type: 'keyword',
	keywords: ['friendly', 'rude', 'barista', 'staff'],
	createTime: daysAgo(150),
	updateTime: daysAgo(12)
}, {
	keywordGroupId: 'kg-speed',
	keywordGroupName: 'Speed',
	type: 'keyword',
	keywords: ['wait', 'slow', 'line', 'quick'],
	createTime: daysAgo(130),
	updateTime: daysAgo(10)
}, {
	keywordGroupId: 'kg-drinks',
	keywordGroupName: 'Drinks',
	type: 'tag',
	tagType: 'review',
	keywords: ['Espresso', 'Pastries'],
	createTime: daysAgo(84),
	updateTime: daysAgo(4)
}, {
	keywordGroupId: 'kg-upkeep',
	keywordGroupName: 'Store upkeep',
	type: 'tag',
	tagType: 'review',
	keywords: ['Cleanliness', 'Wait time', 'Friendly staff'],
	createTime: daysAgo(72),
	updateTime: daysAgo(2)
}]; // Saved Tags & Filters → Manage Filters. Fallback crashes on filterTags.map.

const FILTER_TAGS = [{
	filterTagId: 'ft-wa-stores',
	filterTagName: 'Washington stores',
	filterId: 'f-washington',
	activeFilters: ['Location', 'Geography'],
	gmbDate: daysAgo(177),
	updateDate: daysAgo(20),
	filters: {
		locationFilters: {
			locationIds: ['loc-riverside', 'loc-harbour'],
			country: 'US',
			area: 'WA'
		}
	},
	locationDetails: [{
		locationId: 'loc-riverside',
		locationName: 'Riverside Plaza'
	}, {
		locationId: 'loc-harbour',
		locationName: 'Harbour Point'
	}],
	roleCount: 1,
	reportCount: 1,
	roleDependencies: [{
		roleName: 'Store Manager'
	}],
	reportDependencies: [{
		reportName: 'Weekly Northwest Ops summary'
	}]
}, {
	filterTagId: 'ft-low-ratings',
	filterTagName: 'Low ratings',
	filterId: 'f-low-ratings',
	activeFilters: ['Rating', 'Source'],
	gmbDate: daysAgo(163),
	updateDate: daysAgo(7),
	filters: {
		reviewFilters: {
			starRatingFilter: {
				ratingValues: [1, 2]
			}
		},
		sources: ['google', 'yelp']
	},
	roleCount: 0,
	reportCount: 0,
	roleDependencies: [],
	reportDependencies: []
}, {
	filterTagId: 'ft-or-stores',
	filterTagName: 'Oregon stores',
	filterId: 'f-oregon',
	activeFilters: ['Location', 'Group'],
	gmbDate: daysAgo(125),
	updateDate: daysAgo(28),
	filters: {
		locationFilters: {
			locationIds: ['loc-northgate', 'loc-westfield']
		},
		locationFilterId: 'grp-or-cafes',
		locationFilterName: 'Oregon cafés'
	},
	locationDetails: [{
		locationId: 'loc-northgate',
		locationName: 'Northgate Center'
	}, {
		locationId: 'loc-westfield',
		locationName: 'Westfield Row'
	}],
	roleCount: 0,
	reportCount: 0,
	roleDependencies: [],
	reportDependencies: []
}, {
	filterTagId: 'ft-commented',
	filterTagName: 'Reviews with comments',
	filterId: 'f-commented',
	activeFilters: ['Comments', 'Organization'],
	gmbDate: daysAgo(77),
	updateDate: daysAgo(3),
	filters: {
		reviewTypes: 'comments'
	},
	organizationDetails: [{
		name: 'accounts/loc-riverside',
		accountName: 'Brightside Coffee – Riverside Plaza'
	}],
	roleCount: 0,
	reportCount: 2,
	roleDependencies: [],
	reportDependencies: [{
		reportName: 'Reviews Desk daily digest'
	}, {
		reportName: 'Monthly sentiment'
	}]
}];

const filterComposerItem = (type, section, visible, display, category, showIcon = true) => ({
	id: type,
	type,
	section,
	visible,
	showLabel: true,
	showIcon,
	display,
	category
});

export default {
	// Manage Teams — activeUsers / pausedUsers must be arrays.
	'/getTeams': config => {
		const b = body(config);
		const hits = b.teamId ? TEAMS.filter(t => t.teamId === b.teamId) : TEAMS;
		return {
			status: 200,
			hits,
			total: hits.length
		};
	},
	// Filter Composer (same layout for every tab) and the pickers its preview loads.
	'/getFilterComposer': () => ({
		filters: [filterComposerItem('saved', 'common', true, 'dropdown', 'Saved'), filterComposerItem('location', 'common', true, 'dropdown', 'Location'), filterComposerItem('rating', 'common', true, 'badge', 'Review'), filterComposerItem('source', 'common', true, 'dropdown', 'Review', false), filterComposerItem('tags', 'common', true, 'dropdown', 'Review'), filterComposerItem('groups', 'additional', true, 'dropdown', 'Location'), filterComposerItem('storeCode', 'additional', true, 'dropdown', 'Location', false), filterComposerItem('accounts', 'additional', false, 'dropdown', 'Account')]
	}),
	'/getLocationFilter': () => ({
		docs: [{
			locationId: 'loc-riverside',
			locationName: 'Riverside Plaza',
			friendlyName: 'Riverside Plaza'
		}, {
			locationId: 'loc-northgate',
			locationName: 'Northgate Center',
			friendlyName: 'Northgate Center'
		}, {
			locationId: 'loc-harbour',
			locationName: 'Harbour Point',
			friendlyName: 'Harbour Point'
		}, {
			locationId: 'loc-westfield',
			locationName: 'Westfield Row',
			friendlyName: 'Westfield Row'
		}, {
			locationId: 'loc-elm',
			locationName: 'Elm & 4th',
			friendlyName: 'Elm & 4th'
		}],
		total: 5
	}),
	'/getAllMediaTags': () => ({
		mediaTags: ['Storefront', 'Latte art', 'Patio', 'Baristas'],
		totalHits: 4
	}),
	'/getOrganizationFilter': () => ({
		hits: [{
			name: 'accounts/loc-riverside',
			accountName: 'Brightside Coffee – Riverside Plaza'
		}, {
			name: 'accounts/loc-northgate',
			accountName: 'Brightside Coffee – Northgate Center'
		}],
		total: 2
	}),
	// Saved Tags & Filters
	'/getKeywordGroups': config => {
		const b = body(config);
		const hits = b.keywordGroupId ? KEYWORD_GROUPS.filter(g => g.keywordGroupId === b.keywordGroupId) : KEYWORD_GROUPS;
		return {
			status: 200,
			hits,
			total: hits.length
		};
	},
	'/getAllFilterTags': config => {
		const b = body(config);
		const filterTags = b.filterTagId ? FILTER_TAGS.filter(t => t.filterTagId === b.filterTagId) : FILTER_TAGS;
		return {
			filterTags,
			total: filterTags.length
		};
	},
	// Claim Location (only after a search)
	'/googleLocationsSearch': () => ({
		googleLocations: [{
			location: {
				locationName: 'Brightside Coffee – Riverside Plaza',
				primaryPhone: '(206) 555-0141',
				address: {
					addressLines: ['1420 Riverside Ave'],
					sublocality: 'Belltown',
					locality: 'Seattle',
					regionCode: 'US',
					postalCode: '98101'
				}
			}
		}, {
			location: {
				locationName: 'Brightside Coffee – Northgate Center',
				primaryPhone: '(503) 555-0187',
				address: {
					addressLines: ['88 Northgate Blvd', 'Suite 4'],
					sublocality: 'Pearl District',
					locality: 'Portland',
					regionCode: 'US',
					postalCode: '97209'
				}
			}
		}, {
			location: {
				locationName: 'Brightside Coffee – Harbour Point',
				address: {
					addressLines: ['300 Harbour Point Dr'],
					sublocality: '',
					locality: 'Tacoma',
					regionCode: 'US',
					postalCode: '98402'
				}
			},
			requestAdminRightsUrl: 'https://business.google.com/'
		}]
	})
};